import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

/**
 * Sub-state of the acquisition status "In Arbeit" (IN_PROGRESS), used by the sales agency.
 * SCHEDULED ("Terminiert") is set automatically when a first meeting is booked and cannot be chosen by hand.
 */
export enum AcquisitionProgressStageEnum {
    NOT_REACHED = 'notReached',
    FOLLOW_UP = 'followUp',
    HOT_FOLLOW_UP = 'hotFollowUp',
    SCHEDULED = 'scheduled',
}

export namespace AcquisitionProgressStageEnum {
    type Data = {
        text: string;
        color: string;
        icon: string;
        _sort: number;
    }

    export const Record: Record<AcquisitionProgressStageEnum, Data> = {
        [AcquisitionProgressStageEnum.NOT_REACHED]: {
            text: 'Nicht erreicht',
            color: 'grey',
            icon: 'mdi-phone-off-outline',
            _sort: 0,
        },
        [AcquisitionProgressStageEnum.FOLLOW_UP]: {
            text: 'Follow-Up',
            color: 'info',
            icon: 'mdi-phone-return-outline',
            _sort: 1,
        },
        [AcquisitionProgressStageEnum.HOT_FOLLOW_UP]: {
            text: 'Hot Follow-Up',
            color: 'warning',
            icon: 'mdi-fire',
            _sort: 2,
        },
        [AcquisitionProgressStageEnum.SCHEDULED]: {
            text: 'Terminiert',
            color: 'teal',
            icon: 'mdi-calendar-check',
            _sort: 3,
        },
    };

    export const Items = mapRecordToItems(Record);
    Items.sort((a, b) => a._sort - b._sort);

    /** Stages a sales partner may set by hand; SCHEDULED only comes from a booked first meeting */
    export const ManualStages: AcquisitionProgressStageEnum[] = [
        AcquisitionProgressStageEnum.NOT_REACHED,
        AcquisitionProgressStageEnum.FOLLOW_UP,
        AcquisitionProgressStageEnum.HOT_FOLLOW_UP,
    ];
}
